import { render, staticRenderFns } from "./DbRevisions.vue?vue&type=template&id=032af1ba"
import script from "./DbRevisions.vue?vue&type=script&lang=js"
export * from "./DbRevisions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports